import { combineReducers } from 'redux'

import analytics from 'models/Analytics/reducer'
import profileInfo from 'models/ProfileInfo/reducer'
import profileDownload from 'models/ProfileDownload/reducer'
import redemptions from 'models/Redemptions/reducer'
import rewards from 'models/Rewards/reducer'
import general from 'models/General/reducer'
import authentication from 'models/Authentication/reducer'
import transactions from 'models/Transactions/reducer'
import externalSurveys from 'models/ExternalSurveys/reducer'
import tngSurveys from 'models/TngSurveys/reducer'
import shoppingRewards from 'models/ShoppingRewards/reducer'
import profileRewards from 'models/ProfileRewards/reducer'
import dataFootprint from 'models/DataFootprint/reducer'

const appReducer = combineReducers({
  analytics,
  profileInfo,
  profileDownload,
  redemptions,
  rewards,
  general,
  authentication,
  transactions,
  externalSurveys,
  tngSurveys,
  shoppingRewards,
  profileRewards,
  dataFootprint,
})

export default appReducer
